import { jsx as e } from "react/jsx-runtime";
import { d as i, al as l } from "../../vendor-EQDp64ng.js";
import { Avatar as s } from "../Avatar/index.js";
import { BaseIcon as r } from "../BaseIcon/index.js";
import { Icon as a } from "../Icon/index.js";
import { Hotkey as m } from "../Hotkey/index.js";
import { Pill as d } from "../Pill/index.js";
import '../../assets/index35.css';const f = "_item_o6fr3_1", _ = "_generated_o6fr3_38", b = "_selectable_o6fr3_47", p = "_decorationLeft_o6fr3_56", g = "_decorationRight_o6fr3_65", u = "_label_o6fr3_73", h = "_description_o6fr3_82", c = {
  item: f,
  generated: _,
  selectable: b,
  decorationLeft: p,
  decorationRight: g,
  label: u,
  description: h
};
function R({ as: o, className: n, ...t }) {
  return /* @__PURE__ */ e(o, { ...t, className: i(c.item, n) });
}
const N = ({ avatarProps: o, iconProps: n }) => {
  let t = null;
  return o ? t = /* @__PURE__ */ e(s, { ...o }) : n && (t = /* @__PURE__ */ e(a, { ...n, color: n.color ?? "moon" })), /* @__PURE__ */ e("div", { className: c.decorationLeft, children: t });
}, L = ({ hotkeyProps: o, pillProps: n }) => {
  let t = null;
  return o ? t = /* @__PURE__ */ e(m, { ...o }) : n && (t = /* @__PURE__ */ e(d, { ...n })), /* @__PURE__ */ e("div", { className: c.decorationRight, children: t });
}, v = ({ children: o }) => /* @__PURE__ */ e(l, { elementType: "span", slot: "label", className: c.label, children: o }), x = ({ children: o }) => o ? /* @__PURE__ */ e(l, { elementType: "span", slot: "description", className: c.description, children: o }) : null, E = Object.assign(R, {
  DecorationLeft: N,
  DecorationRight: L,
  Label: v,
  Description: x,
  Selectable: () => /* @__PURE__ */ e("div", { className: i(c.generated, c.selectable), children: /* @__PURE__ */ e(r, { icon: "checkmark2", color: "moon", size: "sm" }) }),
  Submenu: () => /* @__PURE__ */ e("div", { className: c.generated, children: /* @__PURE__ */ e(r, { icon: "chevron-next", color: "moon", size: "sm" }) })
});
export {
  N as DecorationLeft,
  L as DecorationRight,
  x as Description,
  E as ItemRow,
  v as Label
};
